import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { TranslateService } from '@ngx-translate/core';
import { InsideType } from '../../models/inside-type';
import { InsideTypeService } from '../../services/inside-type.service';
import { Inside, InsideItem } from '../../models/inside';
import { InsideService } from '../../services/inside.service';
import { AfterFormPopulated } from '../../../../interfaces/iedit-form';
import { MatTableDataSource } from '@angular/material';
import { EmptyGuid, getUniqueId } from '../../../../modules/shared/functions/core';
import { ItemService } from '../../services/item-service.service';
import { BaseAutoCompleteService } from '../../../../services/base-auto-complete.service';
import { ReferenceAutoComplete } from '../../../../documents/document-reference/reference-auto-complete';

@Component({
  selector: 'app-inside-edit',
  templateUrl: './inside-edit.component.html',
  styleUrls: ['./inside-edit.component.css']
})
export class InsideEditComponent extends EditForm<Inside> implements OnInit, AfterFormPopulated {

  insideTypes: InsideType[];
  locations: ReferenceAutoComplete[];
  items = this.fb.array([]);
  public dataSource: MatTableDataSource<any>;
  public itemColumns: string[] =  ['actions','name','quantity','price'];
  private selectedItem:any;
  constructor(
    ns: ToastrService,          
    tr:TranslateService,
    r: Router,
    ds:InsideService,
    ar: ActivatedRoute,
    l:Location,   
    private insideTypeService:InsideTypeService,
    private autoCompleteService:BaseAutoCompleteService,
    protected itemService: ItemService,
    private fb: FormBuilder,     
  ) { 
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/inside');
  }
  getUniqueId() {
    return getUniqueId(4);
  }  
  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(null),
      newItem: new FormControl(null),
      minWidth: new FormControl(null),
      minDepth: new FormControl(null),
      isDefault: new FormControl(false),
      newQuantity: new FormControl(null),
      newPrice: new FormControl(null),
      itemPrice: new FormControl(0),
      plasardInsideTypeId: new FormControl(),
      locationId: new FormControl(),
      picture: new FormControl(),
      items: this.items
    });
    super.ngOnInit();        
    this.insideTypeService.GetAll().subscribe((data)=>{
      if(data){
        this.insideTypes = data.payload;
      }
    });
    this.autoCompleteService.Query('Plasard-InsideLocation',null).subscribe(result => {
      if(result){
        this.locations = result.payload;
      }
    }) 
  }
  onFileUpload(file:IFileStoreItem){
    if(file){
      this.form.controls['picture'].setValue(file.id);
    }
    else {
      this.form.controls['picture'].setValue(null);
    }
  }
  onItemSelected(item:any){
    console.log('onItemSelected', item);
    this.selectedItem = item;
  }
  onAfterFormPopulated() {      
    if(this.currentData.items){
      this.dataSource = new MatTableDataSource(this.currentData.items);
      this.currentData.items.forEach(item=>{        
        this.items.push(this.initItem(item));
      })
    }
  }
  initItem(data?:InsideItem): FormGroup{

    if(data){
      return this.fb.group({
        id: new FormControl(data.id||'00000000-0000-0000-0000-000000000000'),
        insideId:new FormControl(data.insideId),
        itemId: new FormControl(data.itemId, Validators.required),        
        name: new FormControl(data.name, Validators.required),
        quantity: new FormControl(data.quantity),
        price: new FormControl(data.price),
        priceInternal: new FormControl(data.priceInternal),
        amount: new FormControl(data.amount),
        amountInternal: new FormControl(data.amountInternal)
             });
    }
    else{
      return this.fb.group({
        id: new FormControl('00000000-0000-0000-0000-000000000000'),
        insideId: new FormControl(null),
        itemId: new FormControl(null, Validators.required),
        name: new FormControl(null, Validators.required),
        quantity: new FormControl(null),
        price: new FormControl(null),
        priceInternal: new FormControl(null),
        amount: new FormControl(0),
        amountInternal: new FormControl(0)
             });
    }
  }
  addItem(){
    
    if(this.selectedItem){
      this.itemService.Get(this.selectedItem.id).subscribe(result => {
        if(result){
          let row:InsideItem = new InsideItem();
          row.insideId = this.isEdit?this.id: EmptyGuid();
          row.itemId = result.payload.id;
          row.name = result.payload.name;
          row.quantity = 1;
          row.price = result.payload.price;
          row.priceInternal = result.payload.priceInternal;
          row.amount = 0;
          row.amountInternal = 0;

          this.items.push(this.initItem(row));
          const data = this.dataSource.data;
          data.push(row);  //add the new model object to the dataSource
          this.dataSource.data = data;          
          this.clearSelector();
        }
      })
    }    
  }

  deleteItem(idx:number){
    if (idx > -1) {
      this.items.removeAt(idx);
      let data = this.dataSource.data;
      data.splice(idx,1);      
      this.dataSource.data = data;
    }     
  }
  clearSelector(){
    const item = this.form.get('newItem');
    if(item){
      item.setValue(null);
    }
  }
}